// frontend/src/lib/onesignal.js
// OneSignal v16 helpers using OneSignalDeferred API

// No need for init - it's done in index.html
export function initOneSignal() {
  // Init is handled in index.html using OneSignalDeferred
  console.debug('[OneSignal] Init is handled in index.html');
}

export function registerForPush() {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') return resolve(null);
    
    // Check if notifications are blocked at browser level
    if (window.Notification?.permission === 'denied') {
      console.error('[OneSignal] Notifications are blocked in browser settings. Please enable them in browser settings.');
      alert('Las notificaciones están bloqueadas en tu navegador. Por favor, habilítalas en la configuración del sitio (ícono del candado en la barra de direcciones).');
      resolve(null);
      return;
    }
    
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function(OneSignal) {
      try {
        console.debug('[OneSignal] registerForPush -> SDK ready');
        console.debug('[OneSignal] Current browser permission:', window.Notification?.permission);
        console.debug('[OneSignal] Requesting notification permission...');
        
        // Request permission using v16 API
        const permission = await OneSignal.Notifications.requestPermission();
        console.debug('[OneSignal] Permission result:', permission);
        
        // Check if permission was denied
        if (permission === false || window.Notification?.permission === 'denied') {
          console.warn('[OneSignal] Permission denied by user');
          alert('Necesitas permitir las notificaciones para activar esta función.');
          resolve(null);
          return;
        }
        
        console.debug('[OneSignal] Permission granted, fetching subscription id...');
        
        // Poll for subscription id (may take a moment after permission granted)
        let attempts = 0;
        const maxAttempts = 15;
        const interval = setInterval(() => {
          attempts += 1;
          try {
            const subscriptionId = OneSignal.User.PushSubscription.id;
            const optedIn = OneSignal.User.PushSubscription.optedIn;
            console.debug('[OneSignal] attempt', attempts, 'subscriptionId=', subscriptionId, 'optedIn=', optedIn);
            
            if (subscriptionId && optedIn) {
              clearInterval(interval);
              resolve(subscriptionId);
            } else if (attempts >= maxAttempts) {
              console.warn('[OneSignal] Timeout: no subscription id after', maxAttempts, 'attempts');
              clearInterval(interval);
              resolve(null);
            }
          } catch (e) {
            console.warn('[OneSignal] Error checking subscription id on attempt', attempts, e);
            if (attempts >= maxAttempts) {
              clearInterval(interval);
              resolve(null);
            }
          }
        }, 1000);
      } catch (err) {
        console.error('[OneSignal] Permission request error', err);
        if (err.message && err.message.includes('blocked')) {
          alert('Las notificaciones están bloqueadas. Ve al ícono del candado en la barra de direcciones y permite las notificaciones.');
        }
        resolve(null);
      }
    });
  });
}

// Helper to check if already subscribed (for UI state)
export function isSubscribed() {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') return resolve(false);
    
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function(OneSignal) {
      try {
        const subId = OneSignal.User.PushSubscription.id;
        const optedIn = OneSignal.User.PushSubscription.optedIn;
        resolve(Boolean(subId && optedIn));
      } catch (e) {
        resolve(false);
      }
    });
  });
}

// Unsubscribe helper (OneSignal v16)
export function unsubscribe() {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') return resolve();
    
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function(OneSignal) {
      try {
        await OneSignal.User.PushSubscription.optOut();
        console.debug('[OneSignal] Opted out successfully');
        resolve();
      } catch (e) {
        console.warn('[OneSignal] Opt-out error', e);
        resolve();
      }
    });
  });
}
